export const Stablecoins = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#217A96"/>
    <path d="M10.9922 19.5005C10.9922 21.4405 12.4922 23.0005 14.3322 23.0005H18.0922C19.6922 23.0005 20.9922 21.6405 20.9922 19.9405C20.9922 18.1205 20.1922 17.4605 19.0122 17.0405L12.9922 14.9405C11.8122 14.5205 11.0122 13.8805 11.0122 12.0405C11.0122 10.3605 12.3122 8.98047 13.9122 8.98047H17.6722C19.5122 8.98047 21.0122 10.5405 21.0122 12.4805M15.9922 7V25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

);
